(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("{JSDOM:{}}"));
	else if(typeof define === 'function' && define.amd)
		define("App", ["{JSDOM:{}}"], factory);
	else if(typeof exports === 'object')
		exports["App"] = factory(require("{JSDOM:{}}"));
	else
		root["App"] = factory(root["{JSDOM:{}}"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__15699__) => {
return 